export default __webpack_public_path__ + "static/media/furniture-bg-2.6a55fb09.png";